module.exports = __webpack_public_path__ + "img/jwt.1b2de92d.svg";